import * as c from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { NavbarConfigItem } from 'src/components/navbar/desktop/items/landing-pages/navbar-item.config'

import Button from './button'

interface SectionInterface {
  item: NavbarConfigItem
}

const Section = ({ item }: SectionInterface) => {
  const { t } = useTranslation('components/nav')
  return (
    <c.Box>
      <c.Text fontSize="t-sm.1" fontWeight="bold" color="black.300" mb="s4">
        {item.title}
      </c.Text>

      {item?.options?.map((subItem, i) => {
        return (
          <>
            <Button
              key={subItem.id}
              label={subItem.label}
              path={subItem.path}
              Icon={subItem.Icon}
              lastDivider={i === item?.options?.length! - 1}
            />
            {subItem.id === 'housi-atendimento' && (
              <c.Text
                display={{ md: 'none' }}
                fontSize="t-xs.0"
                bg="black.200"
                my="s2"
                p="s3"
                borderRadius="12px"
              >
                {t('components/nav:INVESTORS-PERSONA.finalText')}
              </c.Text>
            )}
          </>
        )
      })}
    </c.Box>
  )
}

export default Section
